import styled from '../themes/styled'
import { DatePickerSize } from './'

interface InputContainerProps {
    width?: string
    isError?: boolean
    isDisabled?: boolean
    size?: DatePickerSize
    date?: string
}

export const DatePickerInputContainer = styled.div<InputContainerProps>`
    font-family: inherit;
    display: flex;
    .react-datepicker__day--normal {
        font-weight: normal;
    }
    .date-input-area {
        gap: ${({ theme }) => theme.spacing[200]};
        display: flex;
        align-items: center;
        width: ${({ width }): string => (width ? width : 'fit-content')};
        min-width: ${({ width }): string => (width ? width : '224px')};
        box-sizing: border-box;
        height: ${({ size }): string => (size === 's' ? '32px' : '40px')};
        position: relative;
        border: 1px solid
            ${({ isError, theme }): string => (isError ? theme.colors.border.error : theme.colors.border.primary)};
        border-radius: 4px;
        padding: 0 11px;

        &:focus-within {
            border: 1px solid ${({ theme }) => theme.colors.border.neutralActionActive};
        }

        .icon-container {
            display: flex;
            width: 20px;
        }

        .date-icon-container {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        input {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            width: ${({ date, width }): string =>
                width
                    ? date
                        ? // 76: date-input-area input( padding 22px + border 2px + gap 8px ) + date icon size 20px + x button width 20px + date picker input (padding 4px)
                          Number(width.split('px')[0]) - 76 + 'px'
                        : // 56: date-input-area input( padding 22px + border 2px + gap 8px ) + date icon size 20px + date picker input (padding 4px)
                          Number(width.split('px')[0]) - 56 + 'px'
                    : date
                      ? // 224: default width, 76: date-input-area input( padding 22px + border 2px + gap 8px ) + date icon size 20px + x button width 20px + date picker input (padding 4px)
                        224 - 76 + 'px'
                      : // 224: default width, 56: date-input-area input( padding 22px + border 2px + gap 8px ) + date icon size 20px + date picker input (padding 4px)
                        224 - 56 + 'px'};
            border: none;
            color: ${({ isDisabled, theme }) => (isDisabled ? theme.colors.text.disable : theme.colors.text.primary)};
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &:focus {
                outline: none;
            }
        }

        input[placeholder]::placeholder {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            color: ${({ theme }) => theme.colors.text.disable};
        }

        &.disable {
            cursor: default;
            border-color: ${({ theme }) => theme.colors.border.primary};
            background-color: ${({ theme }) => theme.colors.surface.disablePastel};
            input {
                background-color: ${({ theme }) => theme.colors.surface.disablePastel};
            }
        }

        .react-datepicker__current-month {
            font-weight: 700;
            color: ${({ theme }) => theme.colors.text.primary};
        }

        .react-datepicker__day-name {
            font-weight: 500;
            color: ${({ theme }) => theme.colors.text.primary};
        }

        .react-datepicker-time__header {
            font-weight: 700;
            color: ${({ theme }) => theme.colors.text.primary};
        }

        .react-datepicker__day-name,
        .react-datepicker__day,
        .react-datepicker__time-name {
            font-weight: 400;
            color: ${({ theme }) => theme.colors.text.primary};
        }

        .react-datepicker__day--selected {
            font-weight: 400;
            color: ${({ theme }) => theme.colors.text.primaryInverse};
            background-color: ${({ theme }) => theme.colors.surface.action};
        }
        .react-datepicker__day:hover {
            color: ${({ theme }) => theme.colors.text.neutralAction};
            background-color: ${({ theme }) => theme.colors.surface.neutralActionPastelHover};
        }
        .react-datepicker__time-container
            .react-datepicker__time
            .react-datepicker__time-box
            ul.react-datepicker__time-list
            li.react-datepicker__time-list-item--selected {
            font-weight: 400;
            color: ${({ theme }) => theme.colors.text.primaryInverse};
            background-color: ${({ theme }) => theme.colors.surface.action};
            height: 28px;
            padding: 0 10px;
        }

        .react-datepicker__time-container
            .react-datepicker__time
            .react-datepicker__time-box
            ul.react-datepicker__time-list
            li.react-datepicker__time-list-item {
            font-weight: 400;
            display: flex;
            flex-direction: row;
            text-align: center;
            align-items: center;
            height: 28px;
            padding: 0 12px;

            &:hover {
                color: ${({ theme }) => theme.colors.text.neutralAction};
                background-color: ${({ theme }) => theme.colors.surface.neutralActionPastelHover};
            }
        }

        .react-datepicker__time-container
            .react-datepicker__time
            .react-datepicker__time-box
            ul.react-datepicker__time-list {
            &::-webkit-scrollbar {
                width: 12px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(0, 0, 0, 0.6);
                border-radius: 8px;
                border: 4px solid rgba(0, 0, 0, 0);
                background-clip: padding-box;
            }
        }
    }
`

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[100]};
`

export const StyledDatePickerContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[200]};
`

interface ReadOnlyContainerProps {
    width?: string
    size?: DatePickerSize
}

export const StyledReadOnlyContainer = styled.div<ReadOnlyContainerProps>`
    width: ${({ width }): string => (width ? width : '224px')};
    min-height: ${({ size }): string => (size === 's' ? '32px' : '40px')};
    padding: 0px 11px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    box-sizing: border-box;
    border: none;
    border-left: 1px solid ${({ theme }) => theme.colors.border.primary};
    color: ${({ theme }) => theme.colors.text.primary};
    outline: none;
    font-family: inherit;
    gap: ${({ theme }) => theme.spacing[200]};
`
